<template>
  <div>

    <button class="Up_btn"  v-show="butShow" :id="'AttachButton' + _uid" icon="upload"
            :loading="configLoading">
      <div class="ant-upload ant-upload-select-picture-card">
        <div role="button" tabindex="0" class="ant-upload">
          <a-icon type="plus" style="font-size: 40px"/>
          <div class="ant-upload-text">
            上传头像
          </div>
        </div>
      </div>
    </button>

    <div v-for="(file, idx) in uploadFiles" :key="file.id" class="Up_item">
      <viewer>
        <div class="img_box">
          <a-avatar shape="square"
                    :src="file.url"
                    :size="150" style="height: 210px"/>
        </div>
      </viewer>
      <div class="delete">
        <a-popconfirm
            title="是否确认删除?" @confirm="onDelete(file.id)">
          <a-icon type="delete" style="font-size: 16px;"/>
        </a-popconfirm>
      </div>
    </div>
  </div>
</template>

<script>
import {ACCESS_TOKEN} from '@/store/mutation-types'
import plupload from 'plupload'

export default {
  name: 'AvatarUploadSelector',
  props: {
    referId: {
      type: String,
      required: true,
      default: ''
    },
    configKey: {
      type: String,
      required: true
    },
    max: {
      type: Number,
      required: false,
      default: 1
    },
    // 此字段仅用作融合到 Form 检验必须上传功能
    value: {
      type: String
    }
  },
  mounted() {
    this.loadConfig()
    this.refreshData()
  },
  computed: {
    butShow() {
      return !this.uploadFiles || this.uploadFiles.length === 0
    },
  },
  watch: {
    referId(val) {
      this.refreshData()
    }
  },
  data() {
    return {
      user: this.$ls.get('user'),
      access_token: '',
      configLoading: true,
      uploading: false,
      hasError: false,
      config: null,
      uploadFiles: [],
    }
  },
  methods: {
    loadConfig() {
      const that = this
      that.$http.get('/api/1/attachment/config.json?key=' + that.configKey).then(function (response) {
        if (response.code === 200) {
          that.configLoading = false
          that.config = response.result
          that.initUploader()
        }
      })
    },
    onView(idx) {
      let file = this.uploadFiles[idx]
      window.open(file.url)
    },
    getFileIndex(id) {
      return this.uploadFiles.findIndex(item => item.id === id)
    },
    refreshData() {
      const that = this
      if (!that.referId) {
        return
      }
      let configKey = that.configKey
      if (that.isAllCase) {
        configKey = ''
      }
      that.$http.get('/api/1/attachment/attachments.json?referId=' + that.referId + '&configKey=' + configKey).then(function (response) {
        if (response.code !== 200) {
          return
        }
        let files = []
        response.result.forEach(item => {
          let fileObj = {
            id: item.id,
            name: item.name,
            userId: item.userId,
            extension: item.extension,
            size: item.sizeDesc,
            percent: 100,
            response: null,
            clazz: 'ant-upload-list-item-done',
            url: process.env.VUE_APP_WEB_SERVER + '/api/1/attachment/download?id=' + item.id
          }

          files.push(fileObj)
        })
        that.uploadFiles = files
        if (that.uploadFiles.length > 0) {
          that.sendEvent()
        }
      })
    },
    onDelete(fileId) {
      const that = this
      that.$http.get('/api/1/attachment/delete.json?id=' + fileId).then(function (response) {
        if (response.code === 200) {
          that.uploadFiles = that.uploadFiles.filter(file => file.id !== fileId)
        }
        that.sendEvent()
      })
    },
    initUploader() {
      const that = this
      let mimeTypes = []
      let mime = that.config.extension.join(',')
      if (!mime.includes('***')) {
        // console.log('allow exts:' + mime.split('|').join(','))
        mimeTypes.push({title: '文件类型', extensions: mime.split('|').join(',')})
      }
      const uploader = new plupload.Uploader({
        headers: {'X-Auth-Token': that.$ls.get(ACCESS_TOKEN)},
        runtimes: 'html5,flash,html4',
        browse_button: 'AttachButton' + that._uid,
        url: that.$_c + 'api/1/attachment/plupload.json',
        flash_swf_url: '../../../static/plupload/2.3.6/Moxie.swf',
        filters: {
          mime_types: mimeTypes,
          max_file_size: (that.config.maxSize / 1024) + 'kb',
          prevent_duplicates: false
        },
        init: {
          BeforeUpload: function () {
            uploader.setOption('multipart_params', {referId: that.referId, key: that.configKey})
          },
          FilesAdded: function (up, files) {
            if (that.uploadFiles.length + files.length > that.max) {
              that.$warning({title: '最多上传 ' + that.max + ' 个文件'})
              files.map(item => uploader.removeFile(item.id))
              return
            }
            plupload.each(files, function (file) {
              that.uploadFiles.push({
                id: file.id,
                name: file.name,
                userId: that.user.id,
                size: plupload.formatSize(file.size),
                percent: 1,
                response: null,
                clazz: 'ant-upload-list-item-uploading'
              })
            })
            that.uploading = true
            uploader.start()
          },
          UploadProgress: function (up, file) {
            const idx = that.getFileIndex(file.id)
            if (idx < 0) {
              return
            }
            that.uploadFiles[idx].percent = file.percent
          },
          FileUploaded: function (up, file, info) {
            let text = info.response
            let result = /<pre[^>]*>(.*?)<\/pre>/g.exec(info.response)
            if (result) {
              text = result[1]
            }
            let response = JSON.parse(text)
            const idx = that.getFileIndex(file.id)
            if (response.error) {
              that.hasError = true
              that.uploadFiles[idx].percent = file.percent
              that.uploadFiles[idx].response = response.error.message
              that.uploadFiles[idx].clazz = 'ant-upload-list-item-error'
              that.uploadFiles[idx].extension = file.name.split('.').pop()
            } else {
              that.uploadFiles[idx].id = response.id
              that.uploadFiles[idx].percent = file.percent
              that.uploadFiles[idx].response = null
              that.uploadFiles[idx].clazz = 'ant-upload-list-item-done'
              if (response.isExternal === 1) {
                that.uploadFiles[idx].url = response.result
              } else {
                that.uploadFiles[idx].url = process.env.VUE_APP_WEB_SERVER + '/api/1/attachment/download?id=' + response.id
              }
              that.uploadFiles[idx].extension = file.name.split('.').pop()
            }

            that.sendEvent()
          },
          UploadComplete: function (up, files) {
            that.uploading = false
          },
          Error: function (up, err) {
            that.uploading = false
            console.log(err)
            that.$message.error(err.message)
          }
        }
      })
      uploader.init()
    },
    sendEvent() {
      if (this.uploadFiles.length === 0) {
        this.$emit('change', '')
        this.$emit('objChange', null)
      } else {
        this.$emit('objChange', this.uploadFiles)
        this.$emit('change', this.uploadFiles.length)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.Up_btn {
  background: none;
  border: none;
  padding: 0;
}


.ant-upload.ant-upload-select-picture-card {
  float: none;
  width: 150px;
  height: 210px;
}

.Up_item {
  position: relative;
  display: inline-block;
  .img_box {
    position: relative;
    cursor: pointer;
    /deep/ .ant-avatar {
      border: 1px solid #e6e6e6;
    }
    &:after{
      content: "查看大图";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0,0,0,0.4);
      color: #fff;
      opacity: 0;
      transition: all .3s;
      pointer-events: none;
    }
    &:hover{
      &:after{
        opacity: 1;
      }
    }
  }

  .delete {
    width: 32px;
    height: 32px;
    background: #ff0000;
    color: #fff;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: -10px;
    top: -10px;
    cursor: pointer;
  }
}

</style>
